import React from 'react'
import {
  ParagraphSecondary,
  ButtonPrimary,
  TitleSecondary,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import { useHelpContext } from './hooks'

function NotAvailableOnMobile() {
  const { navigation } = useHelpContext()
  return (
    <div>
      <TitleSecondary>
        <Message path="hqm.notAvailableMobile.title" fallback="Not Available" />
      </TitleSecondary>
      <ParagraphSecondary>
        <Message
          path="hqm.notAvailableMobile.paragraph"
          fallback="This content is not available on your device."
        />
      </ParagraphSecondary>
      <SpacerVertical medium />
      <ButtonPrimary onClick={() => navigation.pop()}>
        <Message path="hqm.notAvailableMobile.buttonBack" fallback="Back" />
      </ButtonPrimary>
    </div>
  )
}

export default NotAvailableOnMobile
